import { defineStore } from 'pinia'
import axios from 'axios'

const url = (import.meta as any).env.VITE_API_URL

export const permissionStore = defineStore('permissions', {
  state: () => ({
    permissions: [] as Array<{ name: string }> | null,
  }),

  actions: {
    async loadMyPermissions() {
      try {
        const token = localStorage.getItem('token')
        if (!token) throw new Error('Token não encontrado')

        const resp = await axios.get(url + '/usuariolist/mypermissions/', {
          headers: { Authorization: 'Bearer ' + token },
        })

        localStorage.setItem('permissions', JSON.stringify(resp.data))

        this.permissions = resp.data
      } catch (error) {
        console.error('Erro ao buscar permissões', error)
        this.permissions = null
      }
    },

    loadPermissionsFromStorage() {
      const storedPermissions = localStorage.getItem('permissions')
      if (storedPermissions) {
        this.permissions = JSON.parse(storedPermissions)
      } else {
        this.permissions = null
      }
    },
  },

  getters: {
    hasPermission:
      (state) =>
      (permissionName: string): boolean => {
        if (!state.permissions) return false

        const normalizedPermissionName = normalizathor(permissionName)

        return state.permissions.some((permission) => {
          const normalizedPermission = normalizathor(permission.name)
          return normalizedPermission.includes(normalizedPermissionName)
        })
      },
  },
})

const normalizathor = (param) => {
  return param
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}
